import React, { useState } from "react"

import CopilotPanel from "./CopilotPanel"
import TeacherQuestionsPanel from "./TeacherPrompts"

type TeacherToolsPanelProps = {
  audioRoomId: string
  presentStudents: { fullName: string; id: string }[]
}

const TeacherToolsPanel: React.FC<TeacherToolsPanelProps> = ({
  audioRoomId,
  presentStudents,
}) => {
  const [activeTab, setActiveTab] = useState("aide")

  const tabButtons = [
    { key: "aide", label: "Teacher Aide" },
    { key: "questions", label: "Prompts" },
  ]

  return (
    <section className="flex h-full min-h-0 flex-col overflow-hidden bg-[#111] text-white">
      <div className="flex flex-none border-b border-solid border-neutral-700">
        {tabButtons.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            onClick={() => setActiveTab(key)}
            className={
              "border-b-2 border-solid px-4 py-3 text-sm font-semibold " +
              (activeTab === key
                ? "border-sky-400 text-sky-100"
                : "border-transparent text-neutral-400 hover:text-white")
            }
          >
            {label}
          </button>
        ))}
      </div>

      <CopilotPanel active={activeTab === "aide"} audioRoomId={audioRoomId} />
      <TeacherQuestionsPanel
        active={activeTab === "questions"}
        audioRoomId={audioRoomId}
        presentStudents={presentStudents}
      />
    </section>
  )
}

export default TeacherToolsPanel
